import React, { useState } from 'react';

import AccountCohortsPanel from './AccountCohortsPanel';
import RecipientCohortsPanel from './RecipientCohortsPanel';

type SubView = 'people' | 'accounts';

const SUB_VIEWS: { id: SubView; label: string }[] = [
  { id: 'people', label: 'Personas' },
  { id: 'accounts', label: 'Cuentas' },
];

const CohortsTab: React.FC = () => {
  const [subView, setSubView] = useState<SubView>('people');

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <div className="flex items-center flex-shrink-0 gap-1 px-5 py-3 bg-white border-b">
        <div className="flex items-center gap-1 p-1 bg-gray-100 rounded-full">
          {SUB_VIEWS.map(({ id, label }) => (
            <button
              key={id}
              type="button"
              className={`rounded-full px-4 py-1.5 text-xs font-semibold transition-colors ${
                subView === id ? 'bg-white shadow text-gray-800' : 'text-gray-500'
              }`}
              onClick={() => setSubView(id)}
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="flex-1 overflow-hidden">
        {subView === 'people' && <RecipientCohortsPanel />}
        {subView === 'accounts' && <AccountCohortsPanel />}
      </div>
    </div>
  );
};

export default CohortsTab;
